import { Cell, Legend, Pie, PieChart } from "recharts";
import { Box } from "@mui/material";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);

const TIMEZONE = "America/Sao_Paulo";

export default function PDFPieChart({ data = [], theme = {} }) {
	/// ALTO CONTRASTE
	const COLORS = [
		theme.palette.cardGraphic.graphColor.green,
		theme.palette.cardGraphic.graphColor.red,
		theme.palette.cardGraphic.graphColor.yellow,
		theme.palette.cardGraphic.graphColor.blue,
		theme.palette.cardGraphic.graphColor.orange,
	];

	const customLabel = (props) => {
		if (data?.length > 0) {
			const RADIAN = Math.PI / 180;
			const { cx, cy, midAngle, outerRadius, fill, percent } = props;

			// Controle da distância do texto (aumente o multiplicador para afastar)
			const labelDistance = outerRadius * 1; // <<< Ajuste aqui (1.3 a 1.8 é comum)
			const textOffset = 30; // <<< Ajuste para afastar o texto da linha guia

			// Posição do final da linha guia
			const lineEndX = cx + labelDistance * Math.cos(-midAngle * RADIAN);
			const lineEndY = cy + labelDistance * Math.sin(-midAngle * RADIAN);

			// Posição do texto (afastado da linha guia)
			const textX =
				cx + (labelDistance + textOffset) * Math.cos(-midAngle * RADIAN);
			const textY =
				cy + (labelDistance + textOffset) * Math.sin(-midAngle * RADIAN);

			return (
				<g>
					<line
						x1={cx + outerRadius * 0.9 * Math.cos(-midAngle * RADIAN)}
						y1={cy + outerRadius * 0.9 * Math.sin(-midAngle * RADIAN)}
						x2={lineEndX}
						y2={lineEndY}
						stroke={fill}
					/>
					<circle cx={lineEndX} cy={lineEndY} r={2} fill={fill} />
					<text
						x={textX}
						y={textY}
						textAnchor={Math.cos(-midAngle * RADIAN) >= 0 ? "start" : "end"}
						dominantBaseline="central"
						fontSize={16}
						fontWeight="bold"
						fill={theme.palette.colors.black.medium}
					>
						{`${(percent * 100).toFixed(1)}%`}
					</text>
				</g>
			);
		}
	};

	const customLegend = (value, entry) => {
		return (
			<span
				style={{
					color: theme.palette.colors.black.darker,
				}}
			>{`${value} ${
				data?.lengh > 0 && entry?.payload?.percent
					? "(" +
					  (entry?.payload?.percent * 100)?.toFixed(1)?.toString() +
					  " %)"
					: ""
			}`}</span>
		);
	};

	return (
		<Box>
			<PieChart data={data} width={400} height={240} margin={{ top: -20 }}>
				<Pie
					label={customLabel}
					data={data?.length > 0 ? data : [{ name: "Sem Dados", value: 1 }]}
					cx="50%"
					cy="50%"
					outerRadius={100}
					fill={theme.palette.colors.white.medium}
					isAnimationActive={false}
				>
					{data.map((entry, index) => (
						<Cell key={`cell-${index}`} fill={COLORS[index % COLORS?.length]} />
					))}
				</Pie>
				<Legend
					formatter={customLegend}
					wrapperStyle={{
						fontSize: "16px",
						width: "100%",
						textAlign: "justify",
					}}
				/>
			</PieChart>
		</Box>
	);
}
